import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

import actionsReducer from './slices/actionsSlice';
import blockFieldMapReducer from './slices/activeBlockFieldSlice';
import affordableDocumentReducer from './slices/affordableDocumentSlice';
import applicationScreeningReducer from './slices/applicationScreeningSlice';
import applicationSettingsReducer from './slices/applicationSettingsSlice';
import applicationReducer from './slices/applicationSlice';
import authReducer from './slices/authSlice';
import brandingReducer from './slices/brandingSlice';
import fieldSettingsReducer from './slices/fieldSettingsSlice';
import idIncomeVerificationReducer from './slices/idIncomeVerificationSlice';
import leadProfileReducer from './slices/leadProfileSlice';
import localeReducer from './slices/localeSlice';
import navigationReducer from './slices/navigationSlice';
import notificationsReducer from './slices/notificationsSlice';
import paymentReducer from './slices/paymentSlice';
import petsReducer from './slices/petsSlice';
import propertySettingsReducer from './slices/propertySettingsSlice';
import responseReducer from './slices/responseSlice';
import roommateInvitationReducer from './slices/roommateInvitationSlice';
import shoppingCartReducer from './slices/shoppingCartSlice';
import studentUnitSelectionReducer from './slices/studentUnitSelectionSlice';
import unitSelectionReducer from './slices/unitSelectionSlice';
import userPermissionReducer from './slices/userPermissionSlice';
import validationReducer from './slices/validationSlice';

export const rootReducer = combineReducers({
  auth: authReducer,
  response: responseReducer,
  roommateInvitation: roommateInvitationReducer,
  branding: brandingReducer,
  affordableDocument: affordableDocumentReducer,
  fieldSettings: fieldSettingsReducer,
  leadProfile: leadProfileReducer,
  locale: localeReducer,
  application: applicationReducer,
  applicationSettings: applicationSettingsReducer,
  navigation: navigationReducer,
  payment: paymentReducer,
  shoppingCart: shoppingCartReducer,
  unitSelection: unitSelectionReducer,
  studentUnitSelection: studentUnitSelectionReducer,
  pets: petsReducer,
  applicationScreening: applicationScreeningReducer,
  actions: actionsReducer,
  propertySettings: propertySettingsReducer,
  blockFieldMap: blockFieldMapReducer,
  userPermission: userPermissionReducer,
  validation: validationReducer,
  notifications: notificationsReducer,
  idIncomeVerification: idIncomeVerificationReducer,
});

export const persistConfig = {
  key: 'root',
  storage: storageSession,
  whitelist: [
    'auth',
    'locale',
    'application',
    'applicationSettings',
    'branding',
    'navigation',
    'userPermission',
    'unitSelection',
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
  devTools: process.env.NODE_ENV === 'development',
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
